import { render } from "./IconReload.vue?vue&type=template&id=49b413b2"
import script from "./IconReload.vue?vue&type=script&lang=ts"
export * from "./IconReload.vue?vue&type=script&lang=ts"
script.render = render

export default script